import { requestMs } from "@helpers/api";

export const dailyRent = {
  getDailyRentDetails: ({dailyRentId, rentalType}) => requestMs.get(`/api3/daily_rent/${rentalType}/${dailyRentId}`, {}),
  getDailyRents: ({ userId, search, filter, page, dateFrom, dateTo }) =>
    requestMs.get(`api3/user/${userId}/daily_rent?page=${page}${filter ?? ''}${search ?? ''}${dateFrom ?? ''}${dateTo ?? ''}`, {}),
  requestContract: ({ reservationId }) => requestMs.get(`/api3/daily_rent/reservation/${ reservationId }/request_contract`)
};
